// extracted by mini-css-extract-plugin
module.exports = {"hover":"CiG54"};